export default __webpack_public_path__ + "static/media/interenero.0d1f5d96.png";